import React, { Component } from 'react'
import headLogo from '../../images/headLogo.png'
import NavMenu from './navMenu.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Route, Redirect, Link } from 'react-router-dom'
import CommonFetch from '../../requests/commonFetch'

export default class Menu extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toggleIconClicked: false,
        }

        this.allLanguage = ['en', 'ru']

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    logout = () => {
        CommonFetch({
            path: 'ui/auth/post_logout',
            method: 'POST',
        }).then(data => {
            if (data.success) {
                window.Intercom('shutdown')
                this.props.switchSignIn()
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            } else {
                // TODO: Handle all errors
                console.log('Error:', data.error)
            }
        })
    }

    render() {
        let { toggleIconClicked } = this.state
        let { signIn, language } = this.props

        return (
            <div className="nav">
                <div className="container">
                    <div className="navMenu">
                        <label
                            htmlFor="toggle"
                            className="navMenu_toggleIcon"
                            onClick={this.toggleIconSwitch}
                        >
                            <FontAwesomeIcon
                                icon={toggleIconClicked ? 'times' : 'bars'}
                            />
                        </label>
                        <div className="navMenu_headLogo">
                            <a href="https://cryptaur.com" target="_blank">
                                <img src={headLogo} />
                            </a>
                        </div>
                        {signIn ? <NavMenu /> : null}
                        <div className="navMenu_language">
                            <div className="navMenu_language_select">
                                <FontAwesomeIcon icon={'globe'} />
                                <a className="active_select">
                                    {language}
                                    <ul className="select">
                                        {this.allLanguage.map((item, index) => {
                                            return item === language ? (
                                                <li
                                                    key={index}
                                                    className="active"
                                                >
                                                    {item}
                                                </li>
                                            ) : (
                                                <li
                                                    key={index}
                                                    onClick={
                                                        this.changeLanguage
                                                    }
                                                >
                                                    {item}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </a>
                                <FontAwesomeIcon icon={'sort-down'} />
                            </div>
                        </div>
                        {this.secondBlock()}
                        {this.thirdBlock()}
                    </div>
                </div>
            </div>
        )
    }

    changeLanguage = event => {
        let formData = new FormData(),
            language = event.target.innerHTML
            localStorage.setItem('language', language)
            formData.append('language', language)

        CommonFetch({
            path: 'ui/investor_settings/post_language',
            method: 'POST',
            data: formData,
        }).then(data => {
            if (data.success) {
                window.location.reload(true)
            }
        })
    }


    secondBlock = () => {
        let { signIn } = this.props

        if (!signIn) {
            return (
                <Link to="/registration">
                    <div className="navMenu_register">
                        <span>{this.translation['Register']}</span>
                    </div>
                </Link>
            )
        } else {
            return (
                <Link to={`/investor/settings`}>
                    <div className="navMenu_account_settings">
                        <FontAwesomeIcon icon={'user-cog'} />
                    </div>
                </Link>
            )
        }
    }

    thirdBlock = () => {
        let { signIn } = this.props

        if (!signIn) {
            return (
                <Link to={`/`}>
                    <div className="navMenu_login">
                        <div className="navMenu_login_position">
                            <span>{this.translation['Login']}</span>
                            <FontAwesomeIcon icon={'sign-out-alt'} />
                        </div>
                    </div>
                </Link>
            )
        } else {
            return (
                <Link to={`/`}>
                    <div className="navMenu_logout" onClick={this.logout}>
                        <div
                            className="navMenu_logout_position"
                        >
                            <span>{this.translation['Logout']}</span>
                            <FontAwesomeIcon icon={'sign-out-alt'} />
                        </div>
                    </div>
                </Link>
            )
        }
    }

    toggleIconSwitch = () => {
        this.setState({
            toggleIconClicked: !this.state.toggleIconClicked,
        })
    }
}
